const SystemFilterEvent = {
  SELECTION_CHANGED: 'systemFilterSelectionChanged',
  RESET_FILTER: 'systemFilterResetFilter',
  ADVANCED_FILTER_ACTIVATED: 'advancedFilterActivated',
  ADVANCED_FILTER_DEACTIVATED: 'advancedFilterDeactivated',
  RELOAD_FILTER: 'systemFilterReloadFilter',
  TEXT_CHANGED: 'systemFilterTextChanged',
  START_LOADING_FILTER_OPTIONS: 'startLoadingFilterOptions',
  STOP_LOADING_FILTER_OPTIONS: 'stopLoadingFilterOptions',
};

export default SystemFilterEvent;
